import { computed } from 'vue'
import { useStore } from 'vuex'
import { useApi } from './useApi'

const SYMBOL = { CAD: 'C$', USD: 'U$' }

export function useCurrency() {
  const store = useStore()
  const { get, put } = useApi()

  const userCurrency = computed(() => store.getters['auth/user']?.currency || 'CAD')
  const rate = computed(() => store.getters['settings/cadUsdRate'] ?? 0.73)

  const fetchRate = async () => {
    const res = await get('/get-cad-usd-rate')
    if (res.success) store.commit('settings/SET_RATE', res.data.rate)
    return res
  }

  const saveRate = async (newRate) => {
    const res = await put('/update-cad-usd-rate', { rate: newRate })
    if (res.success) store.commit('settings/SET_RATE', res.data.rate)
    return res
  }

  const format = (amount, currency = userCurrency.value, rateOverride = null) => {
    const n = Number(amount) || 0
    const r = rateOverride ?? rate.value
    const converted = currency === 'USD' ? n * r : n
    return `${SYMBOL[currency]}${converted.toFixed(2)}`
  }

  return { userCurrency, rate, fetchRate, saveRate, format }
}
